import { useNavigate } from 'react-router'
import { CreditsText } from './CreditsText'


const CreditsBottom = () => {
    const navigate = useNavigate()
    
    return (
        <footer className="Credits__Bottom">
            <p className='Credits__Text--Center Credits__SpaceUp Fonts--PlusJakartaSans'><CreditsText /></p>
            <div className='d-flex flex-wrap justify-content-center Fonts--PlusJakartaSans'>
                <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px' }} onClick={() => navigate('/legals/privacy')}>Aviso de privacidad</p>
                <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px', marginLeft: '16px' }} onClick={() => navigate('/contact')}>Contacto</p>
            </div>
        </footer>
    )
}

export { CreditsBottom };